import { ClarionButton } from '@clarion/ClarionButton';
import { cx } from '../../util';
import { useHotkeysDialog } from '../../util/HotkeysDialogContext';
import { useKeyboardShortcutsEnabled } from '../../util/useClarionHotkeys';

const skipLinkClassName =
  'sr-only! focus:not-sr-only! focus:absolute! focus:z-50 focus:top-2 focus:left-2 focus:p-4! bg-gray-100 dark:bg-gray-800';

export default function SkipLink() {
  const { setIsOpen } = useHotkeysDialog();
  const shortcutsEnabled = useKeyboardShortcutsEnabled();

  return (
    <>
      <a href="#main" className={skipLinkClassName}>
        Skip to main content
      </a>

      <ClarionButton
        size="large"
        onClick={() => setIsOpen(true)}
        className={cx(skipLinkClassName, 'focus:left-20')}
      >
        View keyboard shortcuts{' '}
        {shortcutsEnabled && (
          <>
            (press <kbd>?</kbd> to open)
          </>
        )}
      </ClarionButton>
    </>
  );
}
